import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoFileUploadBaseComponent } from '../eo-file-upload-base/eo-file-upload-base.component';
import { EoFileUploadAdvancedConfig } from './eo-file-upload-advanced.model';

@Component({
  selector: 'eo-file-upload-advanced',
  templateUrl: './eo-file-upload-advanced.component.html',
  styleUrl: './eo-file-upload-advanced.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoFileUploadAdvancedComponent),
      multi: true,
    },
  ],
})
export class EoFileUploadAdvancedComponent extends EoFileUploadBaseComponent {
  @Input() dragAndDropSummary?: string;
  @Input() dragAndDropDescription?: string;

  protected override _config?: EoFileUploadAdvancedConfig;
  override get config(): EoFileUploadAdvancedConfig | undefined {
    return this._config;
  }
  override set config(val: EoFileUploadAdvancedConfig | undefined) {
    this._config = val;
  }

  get getDragAndDropSummary(): string {
    return (
      this.dragAndDropSummary ??
      this.config?.dragAndDropSummary ??
      'Παρακαλώ κάντε Drag & Drop τα αρχεία σας εδώ'
    );
  }

  get getDragAndDropDescription(): string {
    return (
      this.dragAndDropDescription ?? this.config?.dragAndDropDescription ?? ''
    );
  }

  get isDragAndDropPromtVisible(): boolean {
    return this.files?.length === 0 || this.getMultiple === true;
  }

  get isRemoveFileVisible(): boolean {
    return this.getMultiple === true;
  }
}
